import { handleVariantOptionsClick } from '../components/product/variantOptions';
import { handleProductNutritionTabClick } from '../components/product/nutritionTab';

handleProductNutritionTabClick();
handleVariantOptionsClick();

$(function () {
  // 1. Shopify Check: Targets standard and alternative product templates
  if (
    $('body').attr('data-template') &&
    $('body').attr('data-template').includes('product')
  ) {
    // 2. Select ONLY the first instance of the pricing container
    const $pricingElement = $('[data-price-wrapper]').first();
    const $destinationElement = $('.product-description.description');

    // Security check to ensure both elements exist
    if ($pricingElement.length && $destinationElement.length) {
      // 3. Create a hidden marker in the DOM using the data attribute
      const $marker = $(
        '<div data-marker="price-original-position" style="display:none;"></div>'
      );
      $pricingElement.before($marker);

      // 4. Define the move logic based on screen width
      function handlePricingPosition() {
        // Updated to 767px breakpoint
        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (isMobile) {
          // If mobile, move it before the description
          if (!$pricingElement.prev().is($destinationElement)) {
            $pricingElement.insertBefore($destinationElement);
          }
        } else {
          // If desktop, snap it back to its original home marker
          if (!$pricingElement.prev().is($marker)) {
            $pricingElement.insertBefore($marker);
          }
        }
      }

      // 5. Run on initial page load
      handlePricingPosition();

      // 6. Handle page resize with a small performance debounce
      console.log(`😬 6`);

      let resizeTimer;
      $(window).on('resize', function () {
        console.log(`😬 resize`);

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handlePricingPosition, 100);
      });
    }
  }
});
